import * as React from 'react';
import styled from 'styled-components';
import { ColorEnum } from '../../enum/color.enum';
import { largeMobileMedia } from '../../util/style/large-mobile-media';
import { Ellipsis } from '../ellipsis';
import { ILinkedInWorkPosition } from '../../interface/component/linkedin-login-response.interface';
import {ContactAvatarIcon} from '../icons';

interface ILinkedInCardProps {
  firstName: string;
  lastName: string;
  headline: string;
  pictureUrl: string;
  currentPosition?: ILinkedInWorkPosition;
  publicProfileUrl: string;
  fillOtherInfoText: string;
  currentLastPositionText: string;
}

const LinkedInCardContainer = styled.div`
  background: ${ColorEnum.White};
  display:flex;
  flex-direction: row;
  padding:20px;
  box-sizing: border-box;
  border-radius: 5px;
  ${largeMobileMedia(`
    flex-direction: column;
  `)};
`;
const AvatarContainer = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
`;
const Avatar = styled.div`
  width:125px;
  height:125px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  & img {
    width:100%;
    border-radius:50%;
  }
`;
const PublicProfileLinkContainer = styled.a`
  outline: none;
  width: 100%;
  height: 100%;
`;
const PositionContainer = styled.div`
  font-size: 18px;
  color: ${ColorEnum.ContentColor};
  font-weight: 600;
`;
const NameContainer = styled.div`
  font-size: 24px;
  color: ${ColorEnum.ContentColor};
`;
const InformationContainer = styled.div`
  display:flex;
  flex-direction: column;
  padding-left: 25px;
  justify-content: center;
  ${largeMobileMedia(`
    text-align: center;
    padding-left: 0px;
  `)};
`;
const LinkedInCardWrapper = styled.div``;
const FillOtherInformationContainer = styled.div`
  font-size: 18px;
  line-height:28px;
  display:flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-top:15px;
  margin-bottom:15px;
  background: ${ColorEnum.AshGray};
  border-radius: 5px;
  padding: 16px;
`;
export const LinkedInCard = (props: ILinkedInCardProps) => {
  return (
    <LinkedInCardWrapper>
      <LinkedInCardContainer>
        <AvatarContainer>
          <Avatar>
            {props.pictureUrl ? <PublicProfileLinkContainer
              href={props.publicProfileUrl}
              target="_blank"
            >
              <img src={props.pictureUrl}/>
            </PublicProfileLinkContainer> :
            <ContactAvatarIcon />}
          </Avatar>
        </AvatarContainer>
        <InformationContainer>
          <NameContainer>
            {props.firstName}&nbsp;{props.lastName}
          </NameContainer>
          <PositionContainer>
            <Ellipsis isEllipsis={false}>
              {props.headline}
            </Ellipsis>
          </PositionContainer>
        </InformationContainer>
      </LinkedInCardContainer>
      <FillOtherInformationContainer>
        {props.fillOtherInfoText}
      </FillOtherInformationContainer>
    </LinkedInCardWrapper>
  );
};
